import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { ObjectUtil } from '../../../../../components/common/object-util/object-util';
import { RdLocalizedNumberPipe } from '../../../pipes/rd-localized-number.pipe';
import { PolluxDynamicFieldConfig } from '../../../pipes/rd-localized-dynamic-field.pipe';
import { WidgetDynamicBaseComponent } from '../../widgetDynamicBase';

@Component({
  selector: 'improved-sales-summary-widget',
  templateUrl: './improved-sales-summary-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './improved-sales-summary-widget.component.scss']
})
export class ImprovedSalesSummaryWidgetComponent extends WidgetDynamicBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("improvedSalesSummary", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }

    this.mockupData$ = this.widgetService.loadMockup('improvedSalesSummary').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('improvedSalesSummary', this.getReport()).pipe();
  }

  /**
   * Constructor
   * @param injector
   */
  constructor(injector: Injector, private rdLocalizedNumberPipe: RdLocalizedNumberPipe) {
    super(injector, 'improvedSalesSummary', false);
  }

  /**
  * Initializes the component
  */
  ngOnInit(): void {
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Pre-process the loaded data.Override if needed
   * @param data The loaded data
   */
  protected preprocessLoadedData(data): any {
    data.labels = {};

    if (data.rows.length) {
      data.rows = data.rows.filter((row) => row.usSalesGridCompSummaryNo);

      const row = data.rows[0];

      for (let i = 1; i <= 24; ++i) {
        const labelName = `usSalesGridCompSummaryCat${i}Label`

        data.labels[labelName] = row[labelName];
      }
      data.labels["usSalesGridCompSummaryEgiLabel"] = row["usSalesGridCompSummaryEgiLabel"];
      data.labels["usSalesGridCompSummaryExpLabel"] = row["usSalesGridCompSummaryExpLabel"];
      data.labels["usSalesGridCompSummaryNoiLabel"] = row["usSalesGridCompSummaryNoiLabel"];


      for (let rowIndex = 0; rowIndex < data.rows.length; ++rowIndex) {
        const row = data.rows[rowIndex];
        row.dynamicData = {};

        for (let i = 1; i <= 24; ++i) {
          const dynamicData: PolluxDynamicFieldConfig = {
            label: row[`usSalesGridCompSummaryCat${i}Label`],
            dateValue: row[`usSalesGridCompSummaryCat${i}DateValue`],
            decimalValue: row[`usSalesGridCompSummaryCat${i}DecimalValue`],
            intValue: row[`usSalesGridCompSummaryCat${i}IntValue`],
            textValue: row[`usSalesGridCompSummaryCat${i}TextValue`],
            numberFormat: row[`usSalesGridCompSummaryCat${i}NumberFormat`]
          };

          row.dynamicData[`usSalesGridCompSummaryCat${i}`] = dynamicData;
        }
      }

    }
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    const data = ObjectUtil.deepCopy(this.widgetData);//deep copy

    return data;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  public getMinimumRowIndex(): number {
    return 1;
  }

  public getMaximumRowIndex(): number {
    if (this.widgetData) {
      return this.widgetData?.rows?.length * 7 + 6;
    }
    return -1;
  }

  public moreColumnsRequestedIfOnPortraitPage(): boolean {
    return false;
  }
}
